export default __webpack_public_path__ + "static/media/win.a91590b4.mp3";